import React from 'react'
import { imagePath } from 'frontend_core/dist/helpers/image'
import { defaultLocale } from 'server/i18n'
import MustHeader from 'components/business/shared/MustHeader'
import {
  GoogleTagManagerHead,
  GoogleTagManagerBody,
} from 'components/business/shared/GoogleTagManager'
import HeaderContainer from 'containers/business/HeaderContainer/home'
import Footer from 'components/business/shared/Footer'
import GlobalStyle from 'styles'

export default function BusinessLayout(props) {
  const { children, config } = props
  const title = i18n.t(props.title || 'server.business.home.title')
  const siteName = i18n.t('server.business.shared.default_site_name')
  const description = i18n.t(
    props.description || 'server.business.shared.default_description',
  )
  const url = props.url || ''
  const image = props.image || imagePath('business/ogp_business.png')
  const bodyClassNames = ['site-business']
  if (props.bodyClassName) bodyClassNames.push(props.bodyClassName)

  const meta = {
    title,
    description,
    og: {
      title,
      description,
      url,
      image,
      siteName,
      type: 'website',
      locale: defaultLocale,
    },
    twitter: {
      title,
      description,
      url,
      image: { src: image },
      card: '',
      site: '@spacemarketjp',
      creator: '@spacemarketjp',
    },
  }

  function renderAll(element) {
    return (
      <html>
        <head>
          <script type="text/javascript" src="https://js.stripe.com/v2/" />
          <script defer src="https://code.getmdl.io/1.2.1/material.min.js" />
          <meta charSet="utf-8" />
          <meta httpEquiv="X-UA-Compatible" content="IE=edge" />
          <meta
            name="viewport"
            content="width=device-width, initial-scale=1, minimum-scale=1, maximum-scale=1, user-scalable=no"
          />
          <title>{meta.title}</title>
          <meta name="description" content={meta.description} />
          <link
            rel="stylesheet"
            href={manifest['business/main.css']}
            media="screen"
          />
          <link
            href="https://use.fontawesome.com/releases/v5.0.10/css/all.css"
            rel="stylesheet"
          />
          <link rel="shortcut icon" href={imagePath('business/favicon.ico')} />
          <meta property="fb:app_id" content={props.config.FB_APP_ID} />
          <meta property="og:site_name" content={meta.og.siteName} />
          <meta property="og:title" content={meta.og.title} />
          <meta property="og:description" content={meta.og.description} />
          <meta property="og:type" content={meta.og.type} />
          <meta property="og:url" content={meta.og.url} />
          <meta property="og:locale" content={meta.og.locale} />
          <meta property="og:image" content={meta.og.image} />
          <link rel="dns-prefetch" href="//business.spacemarket.com" />
          <GoogleTagManagerHead />
          <script
            src="https://browser.sentry-cdn.com/4.5.4/bundle.min.js"
            crossOrigin="anonymous"
          />
        </head>
        <body className={bodyClassNames.join(' ')}>
          <div id="js-root">{renderRoot()}</div>
          <GoogleTagManagerBody />
          <GlobalStyle />
        </body>
      </html>
    )
  }

  function renderRoot() {
    return (
      <div>
        <HeaderContainer {...props} />
        <div className="site-main">{children}</div>
        <Footer />
      </div>
    )
  }
  return config.SSR ? renderAll() : renderRoot()
}
